import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace';

/**
 * This key/value pair is set when the mini-quiz is answered for a category
 *
 * @param taxonomyKey
 * @returns
 */
export const getMiniQuizUserSettingForTaxonomy = (taxonomyKey: VendorTaxonomyKey) =>
  `marketplace:mini-quiz:${taxonomyKey}:answered`;

/**
 * A key/value pair in user settings that limits the prompt modal to show at most once
 * every XX hours.  We'll set this key when the modal is shown and check it before
 * showing the modal again.
 */
export const getMiniQuizPromptTimeoutUserSetting = () => 'marketplace:mini-quiz:prompt-timeout';
